import { useContext, useMemo } from 'react';

import { ValidationFormContext } from '../context';
import type { JSchema } from '../types';
import { createAntdFieldRule } from '../utils/antd-rule';
import { createValibotSchema } from '../utils/valibot';
import { FieldSchema } from './field-schema';
import { FormsRegistryContext } from './forms-registry';

type FormSchemaProps<T extends JSchema> = {
  children: React.ReactNode;
  schema: T;
};

export const FormSchema = <T extends JSchema>({ children, schema: jSchema }: FormSchemaProps<T>) => {
  const registryRef = useContext(FormsRegistryContext);

  const valibotSchema = useMemo(() => createValibotSchema(jSchema), [jSchema]);
  const antdRule = useMemo(
    () =>
      createAntdFieldRule(valibotSchema, () => {
        const allFormsValues: Record<string, unknown> = {};
        if (registryRef) {
          registryRef.current.forEach((form) => {
            Object.assign(allFormsValues, form.getFieldsValue());
          });
        }
        return allFormsValues;
      }),
    [valibotSchema, registryRef],
  );

  return (
    <ValidationFormContext.Provider value={{ antdRule, jSchema, valibotSchema }}>
      {children}
    </ValidationFormContext.Provider>
  );
};

FormSchema.Field = FieldSchema;
